import React from "react"
import styled, { withTheme } from "styled-components"

const IconContainer = styled.div`
  display: ${props => props.inline ? `inline-flex` : `flex`};
  width: ${props => props.width ? props.width : `10px`};
  height: ${props => props.height ? props.height : `12px`};
  margin-right: ${props => props.marginRight ? props.marginRight : `auto`};
  vertical-align: middle;
  ${props => props.padding && `padding: ${props.padding};`}
`

const MapIcon = withTheme(({ theme, ...props }) => (
  <IconContainer {...props}>
    <svg width="100%" height="100%" viewBox="0 0 14 17">
      <g fill="none" fillRule="evenodd">
        <path
          fill={theme.colors.primary}
          stroke={theme.colors.primary}
          d="M11.933 8.88a5.133 5.133 0 0 0 .995-3.031c0-2.97-2.558-5.378-5.714-5.378C4.058.47 1.5 2.878 1.5 5.849c0 1.113.36 2.148.976 3.007l4.696 6.986 4.761-6.963z"
        />
        <path
          fill="#FFF"
          d="M9.84 5.848c0 1.365-1.177 2.471-2.626 2.471-1.45 0-2.625-1.106-2.625-2.47 0-1.365 1.175-2.471 2.625-2.471S9.84 4.484 9.84 5.848z"
        />
      </g>
    </svg>
  </IconContainer>
))

export { MapIcon as default }



// WEBPACK FOOTER //
// ./assets/integration/images/MapIcon.js